// src/components/DesktopOnlySectionGuard.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLaptop, FaShieldAlt, FaArrowLeft } from 'react-icons/fa';
import './AdminMobileRestriction.css';

/**
 * Componente Zen que protege secciones analíticas y contables pesadas en dispositivos móviles,
 * orientando al administrador a ingresar desde su computadora para preservar la precisión de los datos.
 */
const DesktopOnlySectionGuard = ({ tituloSeccion = 'Sección de Escritorio', children }) => {
    const isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const navigate = useNavigate();

    if (!isMobile) {
        return children;
    }

    return (
        <div className="restriction-container" style={{ minHeight: 'calc(100vh - 120px)', width: '100%', maxWidth: '100%', margin: '0 auto', padding: '24px 16px', boxSizing: 'border-box' }}>
            <div className="restriction-card" style={{ maxWidth: '420px', width: '100%', margin: '0 auto', borderRadius: '22px', padding: '36px 24px', boxSizing: 'border-box' }}>
                <div className="restriction-icon-flow" style={{ marginBottom: '20px' }}>
                    <FaLaptop className="icon-desktop" style={{ fontSize: '3rem', color: '#0284c7' }} />
                </div>

                <h1 className="restriction-title" style={{ fontSize: '1.35rem', color: '#0f172a' }}>
                    {tituloSeccion}
                </h1>

                <div className="restriction-divider" style={{ margin: '16px 0' }}></div>

                <p className="restriction-text" style={{ fontSize: '0.95rem', color: '#334155', lineHeight: '1.6' }}>
                    Esta sección contiene <strong>tablas detalladas y herramientas de precisión</strong> diseñadas exclusivamente para pantallas de <strong>computadora o tablet</strong>.
                </p>

                <p className="restriction-subtext" style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '24px' }}>
                    Para consultar o capturar esta información con comodidad y seguridad, te sugerimos ingresar desde tu navegador web de escritorio.
                </p>

                <div className="restriction-actions" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <button
                        type="button"
                        onClick={() => navigate('/vigilancia')}
                        className="btn-primary"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            padding: '12px 20px',
                            background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '12px',
                            fontSize: '0.92rem',
                            fontWeight: 700,
                            cursor: 'pointer',
                            boxShadow: '0 4px 12px rgba(2, 132, 199, 0.3)'
                        }}
                    >
                        <FaShieldAlt /> Ir a Vigilancia y Seguridad
                    </button>
                    <button
                        type="button"
                        onClick={() => window.history.back()}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px',
                            padding: '10px 16px',
                            background: '#f1f5f9',
                            color: '#475569',
                            border: '1px solid #cbd5e1',
                            borderRadius: '12px',
                            fontSize: '0.85rem',
                            fontWeight: 600,
                            cursor: 'pointer'
                        }}
                    >
                        <FaArrowLeft /> Regresar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DesktopOnlySectionGuard;
